import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import {
  withLatestFrom,
  exhaustMap,
  switchMap,
  mergeMap,
  map,
  filter,
  share,
  debounceTime,
  catchError,
} from 'rxjs/operators';
import { BackendService } from '@toro/common/shared/services/backend/backend.service';
import { RoutesTable } from '@toro/common/shared/resources/routes-table.model';
import { DefaultResponse } from '@toro/common/shared/models/form/DefaultResponse';
import { StocksExploreMarketAction } from './stock-explore-market.action';
import { TrendsFilterEnum } from '@toro/common/shared/enum/quote/trends-filter.enum';
import { InstrumentLite } from '@toro/common/shared/models/quote/instrument-lite.model';
import { Instrument } from '@toro/common/shared/models/quote/instrument.model';

@Injectable()
export class StocksExploreMarketEffects {

    /**
     * Busca os ativos de explore o mercado de acordo com o filtro passado.
     */
    @Effect()
    public getTrends$: Observable<StocksExploreMarketAction> = this.actions$
        .pipe(
			ofType(StocksExploreMarketAction.getTrends),
        debounceTime(500),
        switchMap((action) => {
            return this.backendService.get<DefaultResponse>(RoutesTable.composeUri(RoutesTable.quote.routes.getTrends, action.payload))
              .pipe(
                map((result) => {

                    if (result.ok) {
                        let actionToEmit: string;
                        switch (action.payload) {
                            case TrendsFilterEnum.EM_ALTA:
                                actionToEmit = StocksExploreMarketAction.getIsUpTrendSuccess;
                                break;
                            case TrendsFilterEnum.EM_BAIXA:
                                actionToEmit = StocksExploreMarketAction.getIsLowTrendSuccess;
                                break;
                            case TrendsFilterEnum.MAIS_NEGOCIADAS:
                                actionToEmit = StocksExploreMarketAction.getMostTrendSuccess;
                                break;
                            case TrendsFilterEnum.PODE_CAIR:
                                actionToEmit = StocksExploreMarketAction.getCanDownTrendSuccess;
                                break;
                            case TrendsFilterEnum.PODE_SUBIR:
                                actionToEmit = StocksExploreMarketAction.getCanUpTrendSuccess;
                                break;
                        }

                        return { type: actionToEmit, payload: result.value};
                    }

                    return { type: StocksExploreMarketAction.getTrendsError, payload: result.value.map((item) => new InstrumentLite(item)) };
                }),
                catchError((error) => {
                    return of({ type: StocksExploreMarketAction.getTrendsError, payload: error });
                }));
        }),
        share());

    @Effect()
    public searchStock$: Observable<StocksExploreMarketAction> = this.actions$
        .pipe(
			ofType(StocksExploreMarketAction.searchStock),
        mergeMap((action) => {
            const url: string = RoutesTable.composeUri(RoutesTable.quote.routes.newSearch, action.payload.code);

            return this.backendService.get<DefaultResponse>(url)
              .pipe(
                map((result) => {
                    if (result.ok) {
                        return {type: StocksExploreMarketAction.searchStockSuccess, payload: result.value.map((item) => new Instrument(item))};
                    }
                    return {type: StocksExploreMarketAction.searchStockError, payload: result};
                }),
                catchError((error) => {
                    return of({type: StocksExploreMarketAction.searchStockError, payload: error});
                }));
        }),
        share());

        constructor(
            private actions$: Actions<StocksExploreMarketAction>,
            private backendService: BackendService,
        ) { }
}
